module.exports = __webpack_public_path__ + "img/TailWing-Repairing.d635cdf2.jpg";